import { render } from "./ComplianceBadges.vue?vue&type=template&id=77373e29&scoped=true"
import script from "./ComplianceBadges.vue?vue&type=script&lang=js"
export * from "./ComplianceBadges.vue?vue&type=script&lang=js"

import "./ComplianceBadges.vue?vue&type=style&index=0&id=77373e29&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77373e29"]])

export default __exports__